import React, { useState, useEffect, useRef } from "react";
import MUIDataTable from "mui-datatables";
import {
  Grid,
  Button,
  SwipeableDrawer,
  TextField,
  FormControl,
  InputLabel,
  Typography,
  TablePagination,
  Backdrop,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import PageTitle from "../../components/PageTitle";
import { toast } from "react-toastify";
import CloseIcon from "@material-ui/icons/Close";
import axios from "axios";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import Notification from "../../components/Notification";
import moment from "moment";
import "react-toastify/dist/ReactToastify.css";
import useStyles from "../../themes/style.js";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import sample_candidates from "../../images/files/sample_candidates.xlsx";
import "../../css/candidate-profile.css";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useHistory } from "react-router-dom";

export default function VendorSharedCandidates(props) {
  const mobileQuery = useMediaQuery("(max-width:600px)");
  const classes = useStyles();
  const history = useHistory();
  const token = localStorage.getItem("token");
  const candidate_search = window.location.search;
  const positions = [toast.POSITION.TOP_RIGHT];

  const [page, setPage] = useState(0);
  const [count, setCount] = useState(0);
  const [loader, setLoader] = useState(false);
  const [secureCandiData, setSecureCandiData] = useState([]);
  const [viewSecureCandiData, setViewSecureCandiData] = useState(null);
  const [activeModal, setActiveModal] = useState(false);

  var [notificationsPosition] = useState(2);
  var [errorToastId, setErrorToastId] = useState(null);

  const handleOpenModal = (value, type) => {
    setViewSecureCandiData(value);
    setActiveModal(type);
  };

  const handleCloseModal = () => {
    setViewSecureCandiData(null);
    setActiveModal(null);
  };

  function sendNotification(componentProps, options) {
    return toast(
      <Notification
        {...componentProps}
        className={classes.notificationComponent}
      />,
      options,
    );
  }

  function handleNotificationCall(notificationType, message) {
    var componentProps;

    if (errorToastId && notificationType === "error") return;

    switch (notificationType) {
      case "info":
        componentProps = {
          type: "feedback",
          message: message,
          variant: "contained",
          color: "primary",
        };
        break;
      case "error":
        componentProps = {
          type: "message",
          message: message,
          variant: "contained",
          color: "secondary",
        };
        break;
      default:
        componentProps = {
          type: "shipped",
          message: message,
          variant: "contained",
          color: "success",
        };
    }

    var toastId = sendNotification(componentProps, {
      type: notificationType,
      position: positions[notificationsPosition],
      progressClassName: classes.progress,
      onClose: notificationType === "error" && (() => setErrorToastId(null)),
      className: classes.notification,
    });

    if (notificationType === "error") setErrorToastId(toastId);
  }

  const validationSchema = Yup.object().shape({
    requirementName: Yup.string().required("Missing Requirement Name"),
  });

  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  useEffect(() => {
    fetchData({ page });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, page]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const fetchData = async ({ page }) => {
    if (!candidate_search) {
      return;
    }

    axios({
      method: "get",
      url: `${process.env.REACT_APP_SERVER}duplicateCheck/viewAllCandidateList`,
      params: {
        page: page + 1,
        groupId: new URLSearchParams(candidate_search).get("groupId"),
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    })
      .then((response) => {
        if (response.data.status === true) {
          setLoader(false);
          setSecureCandiData(response.data.data);
          setCount(response.data.count);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  async function handleMoveToSecureHash(values) {
    try {
      setLoader(true);
      const response = await axios({
        method: "post",
        url: `${process.env.REACT_APP_SERVER}duplicateCheck/moveToHash`,
        data: {
          requirementName: values.requirementName,
          vendorCandidateListId: viewSecureCandiData.id,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      });
      setLoader(false);

      if (response.data.status === true) {
        handleNotificationCall("success", response.data.message);
        handleCloseModal();
        reset();
        fetchData({ page: 0 });
      } else {
        handleNotificationCall("error", response.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  }

  var table_data = {};

  var table_columns = [];

  table_columns = [
    {
      name: "S.No",
    },
    {
      name: "Email",
    },
    {
      name: "Mobile No",
    },
    {
      name: "Action",
    },
    {
      name: "Posted by",
    },
    {
      name: "Last Updated Date",
    },
  ];

  table_data = secureCandiData.map((item, index) => {
    return [
      <>{page !== 0 ? 10 * page - 10 + index + 1 : index + 1}</>,
      <div className="hashed-file-name">{item.candidateEmail}</div>,
      <div className="hashed-file-name">
        {item.countryCode + item.candidateMobile}
      </div>,
      <Grid container className={classes.space}>
        {item.isMovedToHash ? (
          <Button
            variant="contained"
            className={classes.green}
            size="small"
            type="button"
          >
            Secured
          </Button>
        ) : (
          <Button
            variant="contained"
            color="primary"
            size="small"
            type="button"
            onClick={() => handleOpenModal(item, "move-hash")}
          >
            Secure Candidate
          </Button>
        )}
      </Grid>,
      <div className="hashed-file-name">
        {item.user.recruiter.firstName + " " + item.user.recruiter.lastName}
      </div>,

      moment(item.createdAt).format("DD-MM-YYYY"),
    ];
  });

  const HeaderElements = () => (
    <div style={{ display: "flex", alignItems: "baseline", gap: "4px" }}>
      <div className="card-right">
        <button
          type="button"
          onClick={() => handleOpenModal(undefined, "download-excel")}
          className="download-btn"
        >
          Download
        </button>
      </div>
      <p>Total : {count}</p>
    </div>
  );

  const [state, setState] = useState({
    right: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const generateExcelData = (data, fileName) => {
    if (!data || data.length === 0) {
      handleNotificationCall("error", "No data available to download");
      return;
    }

    try {
      setLoader(true);

      const formattedData = data.map((item, index) => ({
        "S. No": index + 1,
        Name: item.candidateName,
        Email: item.candidateEmail,
        Mobile: item.candidateMobile,
        "Country Code": item.countryCode,
        "Posted By": item.user.recruiter?.firstName+' '+item.user?.recruiter?.lastName,
        "Creation Date": moment(item.createdAt).format("DD-MM-YYYY"),
      }));

      const worksheet = XLSX.utils.json_to_sheet(formattedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Break Report");

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      const dataBlob = new Blob([excelBuffer], {
        type: "application/octet-stream",
      });
      saveAs(dataBlob, `${fileName}.xlsx`);
      handleNotificationCall("success", "Excel downloaded successfully");
      handleCloseModal();
    } catch (error) {
      console.error("Excel download failed:", error);
      handleCloseModal();
    } finally {
      setLoader(false);
    }
  };

  const handleDownloadRecord = async (pageNumber = 1) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER}duplicateCheck/excelDownload/candidateList`,
        {
          params: {
            page: pageNumber,
            groupId: new URLSearchParams(candidate_search).get("groupId"),
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );
      if (response.data.status) {
        const responseData = response.data.data;
        generateExcelData(
          responseData,
          `Secure_Profile_Report_-Part-${pageNumber}`,
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Grid container direction="row" spacing={2} className={classes.heading}>
        <Grid item xs={9} sm={7} md={8} lg={6}>
          <PageTitle title="Vendor Shared Profile" />
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <MUIDataTable
            title={""}
            options={{
              textLabels: {
                body: {
                  noMatch: "Oops! Matching record could not be found",
                },
              },
              pagination: false,
              sort: false,
              selectableRows: "none",
              search: false,
              filter: false,
              print: false,
              download: false,
              customToolbar: () => <HeaderElements />,
              responsive: mobileQuery === true ? "vertical" : "standard",
            }}
            columns={table_columns}
            data={table_data}
          />

          <Grid container spacing={2} className={classes.pagination}>
            <TablePagination
              rowsPerPageOptions={[50]}
              component="div"
              count={count}
              rowsPerPage={10}
              page={page}
              onPageChange={handleChangePage}
            />
          </Grid>
        </Grid>
      </Grid>

      <Dialog
        aria-labelledby="dialog-title"
        onClose={handleCloseModal}
        open={activeModal === "move-hash"}
        width="sm"
        maxWidth="sm"
        PaperProps={{
          style: {
            width: "100%",
          },
        }}
      >
        <DialogTitle className={classes.digTitle}>
          Move this Candidate Secure Hash Group
        </DialogTitle>
        <DialogContent>
          <form onSubmit={handleSubmit(handleMoveToSecureHash)}>
            <Grid
              container
              spacing={2}
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Grid item xs={12}>
                <InputLabel shrink htmlFor="requirementName">
                  Requirement Name
                </InputLabel>
                <FormControl className={classes.margin}>
                  <TextField
                    InputProps={{ disableUnderline: true }}
                    classes={{ root: classes.customTextField }}
                    size="small"
                    placeholder="Requirement Name"
                    name="requirementName"
                    {...register("requirementName")}
                    error={errors.requirementName ? true : false}
                  />

                  <Typography variant="inherit" color="error">
                    {errors.requirementName?.message}
                  </Typography>
                </FormControl>
              </Grid>

              <div
                style={{
                  display: "flex",
                  justifyContent: "end",
                  gap: "6px",
                  width: "100%",
                  margin: "10px 0px",
                }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  type="submit"
                >
                  Move to Secure Group
                </Button>
              </div>
            </Grid>
          </form>
        </DialogContent>
      </Dialog>

      <Dialog
        onClose={handleCloseModal}
        aria-labelledby="dialog-title"
        open={activeModal === "download-excel"}
        width="md"
        PaperProps={{
          style: {
            width: "100%",
          },
        }}
      >
        <DialogTitle className={classes.digTitle}>
          <div className={classes.center}>
            <Typography
              variant="subtitle2"
              className={classes.digColor + " " + classes.digCenter}
            >
              Download Excel
            </Typography>

            <div className={classes.drawerClose}>
              <CloseIcon
                className={classes.digClose}
                size="14px"
                onClick={handleCloseModal}
              />
            </div>
          </div>
        </DialogTitle>

        <DialogContent className={classes.chatListBackGround}>
          <div className="download-card">
            <div className="card-header">
              <div className="card-left">
                <div className="icon-wrapper">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="800px"
                    height="800px"
                    viewBox="0 0 32 32"
                    className="excel-icon"
                  >
                    <title>file_type_excel2</title>
                    <path
                      d="M28.781,4.405H18.651V2.018L2,4.588V27.115l16.651,2.868V26.445H28.781A1.162,1.162,0,0,0,30,25.349V5.5A1.162,1.162,0,0,0,28.781,4.405Zm.16,21.126H18.617L18.6,23.642h2.487v-2.2H18.581l-.012-1.3h2.518v-2.2H18.55l-.012-1.3h2.549v-2.2H18.53v-1.3h2.557v-2.2H18.53v-1.3h2.557v-2.2H18.53v-2H28.941Z"
                      style={{ fill: "#20744a", fillRule: "evenodd" }}
                    />
                    <rect
                      x="22.487"
                      y="7.439"
                      width="4.323"
                      height="2.2"
                      style={{ fill: "#20744a" }}
                    />
                    <rect
                      x="22.487"
                      y="10.94"
                      width="4.323"
                      height="2.2"
                      style={{ fill: "#20744a" }}
                    />
                    <rect
                      x="22.487"
                      y="14.441"
                      width="4.323"
                      height="2.2"
                      style={{ fill: "#20744a" }}
                    />
                    <rect
                      x="22.487"
                      y="17.942"
                      width="4.323"
                      height="2.2"
                      style={{ fill: "#20744a" }}
                    />
                    <rect
                      x="22.487"
                      y="21.443"
                      width="4.323"
                      height="2.2"
                      style={{ fill: "#20744a" }}
                    />
                    <polygon
                      points="6.347 10.673 8.493 10.55 9.842 14.259 11.436 10.397 13.582 10.274 10.976 15.54 13.582 20.819 11.313 20.666 9.781 16.642 8.248 20.513 6.163 20.329 8.585 15.666 6.347 10.673"
                      style={{ fill: "#ffffff", fillRule: "evenodd" }}
                    />
                  </svg>
                </div>
                <div className="card-text">
                  <div className="card-title">
                    Secured Candidate Profile Records
                  </div>
                </div>
              </div>
              <div className="card-right">
                <button
                  type="button"
                  onClick={() => handleDownloadRecord(1)}
                  className="download-btn"
                >
                  Download
                </button>
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      <SwipeableDrawer
        anchor="right"
        open={state["right"]}
        onClose={toggleDrawer("right", false)}
        onOpen={toggleDrawer("right", true)}
        classes={{ paper: classes.drawer }}
      >
        {/* {list("right")} */}
      </SwipeableDrawer>

      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}
